import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { Center, Group, Input, Space, Stack } from "@mantine/core";
import { IconGripVertical } from "@tabler/icons-react";
import type { ReactNode } from "react";
import type { IDElement } from "../../models/IDElement";

type SortableListProps<T extends IDElement> = {
  reorderListItem: (from: number, to: number) => void;
  label?: string;
  itemRender: (index: number) => ReactNode;
  values: T[];
  maw?: string;
  detailLabels?: ReactNode;
};

export function SortableList<T extends IDElement>({ label, reorderListItem, itemRender, values, maw, detailLabels }: SortableListProps<T>) {
  const _detailLabels = (
    <Group>
      <Space w={18} />
      {detailLabels}
    </Group>
  );

  const fields = values.map((item, index) => (
    <Draggable key={item.id} index={index} draggableId={item.id}>
      {(provided) => (
        <Group maw={maw} ref={provided.innerRef} mt="xs" {...provided.draggableProps}>
          <Center maw="2rem" {...provided.dragHandleProps}>
            <IconGripVertical size={18} />
          </Center>
          {itemRender(index)}
        </Group>
      )}
    </Draggable>
  ));
  return (
    <Stack gap="xs">
      <Input.Label>{label}</Input.Label>
      <DragDropContext
        onDragEnd={({ destination, source }) => destination?.index !== undefined && reorderListItem(source.index, destination.index)}
      >
        <Droppable droppableId="dnd-list" direction="vertical">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {detailLabels && _detailLabels}
              {fields}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Stack>
  );
}
